<template>
  <div class="tan zy_kcadd">
    <div class="px_add_con">
      <div class="h370 rdiv">
        <h3>添加资源</h3>
        <div class="add_kc_search">
          <select name="" class="all_select" v-model="filter.type" @change="getResources(filter, excludeIdsArr)">
            <option value="">全部(资源类型)</option>
            <option v-for='item in Dropdown.state.resourceType' :key="item.value" :value="item.value">{{item.label}}</option>
          </select><input type="button" class="btn_s" @click="getResources(filter, excludeIdsArr)" /><input name="title" type="text" class="text_put" v-model="filter.title" @keyup.13="getResources(filter, excludeIdsArr)" /></div>
        <a  href="javascript:void(0);"  class="close" @click="$emit('close')" ></a>
        <p>没有合适的课程资源，您可以<router-link to="/org/resource/create">上传新资源</router-link></p>
        <div class="h295">
          <table width="710" border="0" cellspacing="0" cellpadding="0">
            <thead>
            <tr>
              <td width="15%"><input type='checkbox' :checked="(selectedIdArr.length === list.length) && list.length != 0" @click='checkedAll()' style="opacity: 1">全选选择</td>
              <td width="85%">资源名称</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in list" :key="item.id">
              <td><input type="checkbox" :checked="selectedIdArr.indexOf(item.id)>=0" @click='checkedOne(item.id)' style="opacity: 1"/></td>
              <td>{{item.title}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="clear"></div>
      <div class="modalPagination" v-if="list.length>0">
        <Paginate :click-handler="clickCallback" :page-count=pages
                  :container-class="'pagination-center'" :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                  :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                  :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                  :first-last-button=$global.paginationOptions.first_last_button
                  :active-class=$global.paginationOptions.active_class
                  :disabled-class=$global.paginationOptions.disabled_class
                  :first-button-text=$global.paginationOptions.first_button_text
                  :last-button-text=$global.paginationOptions.last_button_text
                  :prev-text=$global.paginationOptions.prev_text
                  :next-text=$global.paginationOptions.next_text></Paginate>
      </div>

      <div class="w240 wrap">
        <input name="" type="button" value="确定" class="all_btn" @click="setSelectedResource()" />
        <input name="" type="button" value="取消" @click="$emit('close')" class="all_btn color_hui" />
      </div>
    </div>
  </div>
</template>

<script>
  import Paginate from 'vuejs-paginate'
  import Dropdown from '@/store/modules/dropdowns'
  import Bus from '@/utils/bus'
  export default {
    components: { Paginate },
    props: ['data', 'chapterName'],
    data () {
      return {
        id: 0,
        Dropdown: Dropdown,
        pages: 0,
        list: [],
        filter: {
          pageNo: 1,
          pageSize: this.$global.paginationOptions.page_num,
          tranceStatus: '1',
          state: '0',
          type: '',
          excludeIds: []
        },
        excludeIdsArr: this.data,
        dealArr: [],
        selectedIdArr: [],
        isCheckedAll: false
      }
    },
    mounted () {
      this.getResources(this.filter, this.excludeIdsArr)
    },
    methods: {
      clickCallback (pageNum)  {
        this.filter.pageNo = pageNum
        this.getResources(this.filter, this.excludeIdsArr)
      },
      dealExcludeIds (arr) {
        var filterArr = []
        if (arr && arr.length>0) {
          for (var i = 0; i<arr.length; i++) {
            var exclude = {id: arr[i].sourceList[0].sourceId, name: arr[i].name}
            filterArr.push(exclude)
          }
        }
        return filterArr
      },
      getResources (filter, list) {
        this.selectedIdArr = []
        if (list && list.length > 0) {
          this.dealArr = this.dealExcludeIds(list)
          if (this.dealArr && this.dealArr.length>0) {
            for (var i = 0; i<this.dealArr.length; i++) {
              filter.excludeIds.push(this.dealArr[i].id)
            }
          }
        }
        this.$api.post(this.$global.resourceApiPath, '/resource/resources', filter, r => {
          this.pages = Math.ceil(r.cntData / this.$global.paginationOptions.page_num)
          if (r.data && r.data.length>0) {
            this.list = r.data
          } else {
            this.list = []
          }
        })
      },
      checkedOne (id) {
        let idIndex = this.selectedIdArr.indexOf(id)
        if (idIndex >= 0) {
          this.selectedIdArr.splice(idIndex, 1)
        } else {
          this.selectedIdArr.push(id)
        }
      },
      checkedAll () {
        this.isCheckedAll = !this.isCheckedAll
        if (this.isCheckedAll) {
          this.selectedIdArr = []
          if (this.list.length>0) {
            for (var i = 0; i<this.list.length; i++) {
              this.selectedIdArr.push(this.list[i].id)
            }
          }
        } else {
          this.selectedIdArr = []
        }
      },
      setSelectedResource () {
        var resultArr = []
        var emitState = false
        for (var i = 0; i<this.selectedIdArr.length; i++) {
          var temp = {
            id: this.selectedIdArr[i],
            name: this.chapterName
          }
          resultArr.push(temp)
          if (i == this.selectedIdArr.length-1) {
            emitState = true
          }
        }
        if (emitState) {
          Bus.$emit('selectedResources', this.dealArr.concat(resultArr))
          this.$emit('close')
        }
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/byl/org/resource/select.vue